import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// Mobile-only sticky CTA. Appears after slight scroll, hidden on conversion pages.
export function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  const hide =
    location.pathname.startsWith("/contact") ||
    location.pathname.startsWith("/book-call") ||
    location.pathname.startsWith("/ai-tech-readiness-audit");

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (hide || !visible) return null;

  return (
    <div
      className="lg:hidden fixed bottom-4 left-4 right-20 z-40"
      role="complementary"
      aria-label="Quick contact"
    >
      <Link
        to="/book-call"
        className="group flex items-center justify-center gap-2 w-full rounded-full bg-white text-[hsl(248_62%_21%)] px-5 py-3.5 font-semibold text-sm shadow-[0_20px_50px_-15px_rgba(0,0,0,0.7)] border border-white/40"
      >
        Book a Call
        <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
      </Link>
    </div>
  );
}
